import { Injectable, computed, signal } from '@angular/core';
import { SignupAddress } from '../address/signup-address.store';
import { ContactFormValue } from '../contact/contact-form.store';

/** The /signup answers a direct quote starts from */
export interface DirectQuoteAnswers {
  address: SignupAddress;
  contact: ContactFormValue;
}

/**
 * Holds what DirectQuoteService sends to dot-com. /enrolled clears the sign-up stores on arrival, so it captures their
 * answers here first; the date of birth is added on /enrolled. Memory only (never storage), and cleared when /enrolled
 * is left.
 */
@Injectable({ providedIn: 'root' })
export class DirectQuoteStore {
  readonly answers = signal<DirectQuoteAnswers | null>(null);
  /** YYYY-MM-DD, set only once the entered date is valid (see `parseBirthDate`) */
  readonly dob = signal<string | null>(null);

  /** False once the answers are gone (/enrolled reloaded or reopened after clearing them); /enrolled asks to start over. */
  readonly canQuote = computed(() => this.answers() !== null);
  readonly state = computed(() => this.answers()?.address.state);

  /** Copies the sign-up answers, or clears them when there's no address. */
  capture(address: SignupAddress | null, contact: ContactFormValue): void {
    this.answers.set(address ? { address: { ...address }, contact: { ...contact } } : null);
    this.dob.set(null);
  }

  reset(): void {
    this.answers.set(null);
    this.dob.set(null);
  }
}
